/**
 * sj-curated-for-you.js
 *
 * 1. Typewriter heading — "Shop " stays fixed, the rotator types/deletes words
 *    after it: "by Need", "by Season", "the Slow Way", "Organic", "for Your Kitchen"
 *    Triggered once when the heading scrolls into view (matches homepage.html).
 *
 * 2. Scroll-reveal for the need tiles — same pop-in animation as the reference
 *    (.reveal-item up → .in-view), but namespaced to this section.
 *
 * No dependencies — vanilla JS only.
 */

(function () {
  'use strict';

  /* ── 1. TYPEWRITER ──────────────────────────────────────────────────────── */
  function initTypewriter(section) {
    var rotator = section.querySelector('#sjNeedRotator');
    var heading  = section.querySelector('#sjNeedHeading');
    if (!rotator || !heading) return;

    /* Words come from a JSON data-attribute stamped by Liquid, or fall back. */
    var defaultWords = ['by Need', 'by Season', 'the Slow Way', 'Organic', 'for Your Kitchen'];
    var wordsRaw = heading.getAttribute('data-words-json') || '';
    var words = defaultWords;
    if (wordsRaw) {
      try {
        var parsed = JSON.parse(wordsRaw);
        var filtered = parsed
          .map(function (w) { return (w || '').trim(); })
          .filter(Boolean);
        if (filtered.length) words = filtered;
      } catch (e) { /* fall back to defaults */ }
    }

    var wordIndex  = 0;
    var charIndex  = 0;
    var deleting   = false;
    var started    = false;

    var TYPE_SPEED   = 65;
    var DELETE_SPEED = 38;
    var HOLD_TIME    = 1500;
    var START_GAP    = 250;

    function tick() {
      var current = words[wordIndex] || '';

      if (!deleting) {
        charIndex++;
        rotator.textContent = current.slice(0, charIndex);
        if (charIndex === current.length) {
          deleting = true;
          setTimeout(tick, HOLD_TIME);
          return;
        }
        setTimeout(tick, TYPE_SPEED);
      } else {
        charIndex--;
        rotator.textContent = current.slice(0, charIndex);
        if (charIndex === 0) {
          deleting   = false;
          wordIndex  = (wordIndex + 1) % words.length;
          setTimeout(tick, START_GAP);
          return;
        }
        setTimeout(tick, DELETE_SPEED);
      }
    }

    function start() {
      if (started) return;
      started = true;
      setTimeout(tick, 300);
    }

    if (!('IntersectionObserver' in window)) {
      start();
    } else {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            start();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(heading);
    }
  }

  /* ── 2. SCROLL-REVEAL FOR TILES ─────────────────────────────────────────── */
  function initTileReveal(section) {
    var tiles = Array.prototype.slice.call(
      section.querySelectorAll('.sj-cfy-tile')
    );
    if (!tiles.length) return;

    if (!('IntersectionObserver' in window)) {
      tiles.forEach(function (t) { t.classList.add('sj-cfy-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry || !entry.isIntersecting) return;
        var tile = entry.target;
        tile.classList.add('sj-cfy-in-view');
        observer.unobserve(tile);
      });
    }, {
      threshold:  0.15,
      rootMargin: '0px 0px -20px 0px'
    });

    tiles.forEach(function (tile) { observer.observe(tile); });
  }

  /* ── INIT ────────────────────────────────────────────────────────────────── */
  function init() {
    var sections = document.querySelectorAll('[data-sj-cfy-section]');
    sections.forEach(function (section) {
      initTypewriter(section);
      initTileReveal(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Theme Editor live-reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector('[data-sj-cfy-section]');
    if (section) {
      initTypewriter(section);
      initTileReveal(section);
    }
  });

})();
